/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-no-useless-fragment */
import { Card, Tooltip, Spin, Button } from 'antd';
import React from 'react';
import { InfoCircleOutlined, ReloadOutlined, LoadingOutlined } from '@ant-design/icons';
import { DonutChart } from 'bizcharts';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getDriverStatisticsByPeriod } from '../../redux/dashboardSlice';
import NoData from './NoData';

const DriversPieChart = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);

	const { dashboard } = useSelector((state) => state.dashboard);

	const reload = () => {
		fetchRidesPieChartData();
	};
	const fetchRidesPieChartData = async () => {
		setLoading(true);
		dispatch(getDriverStatisticsByPeriod())
			.then()
			.catch()
			.finally(() => {
				setLoading(false);
			});
	};
	
	const formatDriverData = (data) => {
		return data?.map(item => ({
			...item,
			type: item.type ? item.type.replace(/_/g, ' ') : item.type
		})) || [];
	};
	
	const handleChartClick = () => {
		navigate('/app/main/driver');
	};
	
	return (
		<Spin
			size='large'
			indicator={<LoadingOutlined style={{ fontSize: 54 }} spin />}
			tip={
				<div>
					<h2>Loading...</h2>
				</div>
			}
			spinning={loading}>
			<Card
				type='inner'
				title='Drivers'
				extra={
					<div>
						<Tooltip title='Track driver application statuses: Approved, Pending, Denied, and Denied Renewal.'>
							<InfoCircleOutlined />
						</Tooltip>
						<Button
							style={{
								marginLeft: '1em',
							}}
							type='default'
							size='small'
							onClick={() => reload()}>
							<ReloadOutlined />
						</Button>
					</div>
				}
				bordered={false}
				style={{
					width: '100%',
				}}>
				{dashboard?.driversCount?.length === 0 ? (
					<NoData height={300} />
				) : (
					<div 
						onClick={handleChartClick}
						style={{ cursor: 'pointer' }}
						role="button"
						tabIndex={0}
						onKeyDown={(e) => {
							if (e.key === 'Enter' || e.key === ' ') {
								handleChartClick();
							}
						}}>
						<DonutChart
							data={formatDriverData(dashboard?.driversCount)}
							autoFit
							height={300}
							radius={0.7}
							padding='auto'
							angleField='value'
							colorField='type'
							pieStyle={{
								stroke: 'white',
								lineWidth: 5,
							}}
						/>
					</div>
				)}
			</Card>
		</Spin>
	);
};

export default DriversPieChart;
